export const stayPromotions = {
  title: "Stay promotions",
  description: "Offer special discounts to your guests for longer stays",
  newPromotion: "New promotion",
  loading: "Loading promotions...",
  close: "Close",
  cancel: "Cancel",
  noLimit: "No limit",

  status: {
    active: "Active",
    paused: "Paused",
  },

  card: {
    stay: "Stay",
    discount: "Discount",
    validity: "Validity",
    edit: "Edit",
    delete: "Delete",
  },

  nights: {
    range: "{min} - {max} nights",
    min: "{min}+ nights",
  },

  empty: {
    title: "No promotions set up",
    description: "Create promotions to encourage longer stays and boost your bookings",
    create: "Create first promotion",
  },

  form: {
    editTitle: "Edit promotion",
    createTitle: "New promotion",
    nameLabel: "Promotion name",
    namePlaceholder: "e.g. 7-night discount, Weekly deal",
    minNights: "Minimum nights",
    maxNights: "Maximum nights",
    optional: "(optional)",
    noLimitPlaceholder: "No limit",
    discountType: "Discount type",
    percentage: "Percentage",
    fixedAmount: "Fixed amount",
    discountValue: "Discount value",
    validFrom: "Valid from",
    validTo: "Valid until",
    activateNow: "Activate promotion immediately",
    saving: "Saving...",
    update: "Update",
    create: "Create promotion",
  },

  invoice: {
    title: "Savings example",
    pricePerNight: "Price per night",
    numberOfNights: "Number of nights",
    subtotal: "Subtotal",
    discountApplied: "Discount applied",
    totalToPay: "Total to pay",
    guestSaves: "The guest saves {amount}",
  },

  statusModal: {
    activateTitle: "Activate promotion",
    pauseTitle: "Pause promotion",
    activateDescription: 'Do you want to activate the promotion "{name}" so it applies to new bookings?',
    pauseDescription: 'Do you want to pause the promotion "{name}"?',
    confirm: "Confirm",
  },

  deleteModal: {
    title: "Delete promotion",
    warningStrong: "This action cannot be undone.",
    warningText: "Before deleting, make sure you no longer need the promotion {name}.",
    confirmLabel: "Type the exact name to confirm:",
    confirmPlaceholder: "Type the promotion name exactly",
    hint: "Paste or type the name exactly as it appears above to enable the delete button.",
    deleting: "Deleting...",
    confirmDelete: "Delete permanently",
  },

  toasts: {
    nameRequired: "Please enter a name",
    minNightsWarning: "Minimum nights must be 1 or more",
    selectRatePlan: "Select a base rate plan",
    updated: "Promotion updated",
    created: "Promotion created",
    saveFailed: "Could not save",
    saveError: "Error while saving",
    activated: "Promotion activated",
    pausedToast: "Promotion paused",
    updateFailed: "Could not update",
    statusError: "Error changing status",
    deleted: "Promotion deleted",
    deleteFailed: "Could not delete",
    deleteError: "Error while deleting",
  },
};
